import type { NavigationGuard } from "vue-router";
import { RoutePath } from "@/App/router/routePath";
import { CaseListType, type OptionsStore, useOptionsStore } from "@/App/options/options.store";
import storage from "@/App/services/storage.service";
import { getUserOptionsKey } from "@/App/options/getUserOptionsKey";

export const setMapviewAsDefaultForMih: NavigationGuard = (to, _, next) => {
  const optionsStore = useOptionsStore();
  if (to.path == RoutePath.mih) {
    optionsStore.setCasesListType(CaseListType.Map, false);
    return next();
  }

  const lastCaseListType = storage.getItemAsObject<OptionsStore>(getUserOptionsKey());
  optionsStore.setCasesListType(lastCaseListType?.caseListType ?? CaseListType.Default);
  next();
};
